export default __webpack_public_path__ + "static/media/industry-vision-dm.eff84610.svg";